"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_intl_1 = require("react-intl");
const transactionSigningSelector_1 = require("../selectors/transactionSigningSelector");
const transactionSigningAction_1 = require("../actions/transactionSigningAction");
const CommonErrorStyle_1 = __importDefault(require("./styles/CommonErrorStyle"));
const material_1 = require("@mui/material");
const InvalidOfflineOTP = () => {
    const classes3 = (0, CommonErrorStyle_1.default)();
    const intl = (0, react_intl_1.useIntl)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { showInvalidOfflineOTP } = (0, react_redux_1.useSelector)(transactionSigningSelector_1.transactionSigningSelector);
    const handleToggleCloseInvalid = (cancel) => {
        console.log('handleToggleCloseInvalid');
        dispatch((0, transactionSigningAction_1.toggleCloseInvalidOfflineOTP)(false));
    };
    return (react_1.default.createElement(material_1.Dialog, { open: showInvalidOfflineOTP, classes: { paper: classes3.dialog }, TransitionComponent: material_1.Slide, onClose: () => console.log('dismiss') },
        react_1.default.createElement("div", { style: {
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center'
            } },
            react_1.default.createElement(material_1.Typography, { variant: "h3", className: classes3.Error2FATitle },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "invalid-otp-title" })),
            react_1.default.createElement(material_1.Link, { onClick: () => handleToggleCloseInvalid(true), className: classes3.IconClose })),
        react_1.default.createElement(material_1.DialogContent, { id: "dialogOfflineOTP", className: classes3.DialogContent },
            react_1.default.createElement(material_1.ListItem, { id: "listOfflineOTP", className: classes3.ListItem },
                react_1.default.createElement(material_1.ListItemIcon, { className: classes3.WrapIcon }),
                react_1.default.createElement(material_1.ListItemText, { id: "listTextOfflineOTP" },
                    react_1.default.createElement(material_1.Typography, { className: classes3.typography },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "invalid-otp-message" })))),
            react_1.default.createElement("div", { className: classes3.ConfirmButton },
                react_1.default.createElement(material_1.Button, { className: classes3.OK, name: "submit", onClick: () => handleToggleCloseInvalid(false), disableTouchRipple: true, disableFocusRipple: true }, intl.formatMessage({ id: 'login-2fa-otp-invalid-otp-btn-ok' }))))));
};
exports.default = InvalidOfflineOTP;
